import comp from "./CrownPremiumFilledWrapper";
export default comp;
